import { header3 } from 'shared/theme/typography'
import styled, { css } from 'styled-components'

export const StatusBadge = styled.div<{ $color: string; $backgroundColor: string }>`
  ${header3};
  padding: 3px 10px 2px;
  display: inline-block;
  border-radius: 3px;

  ${(p) => css`
    color: ${p.$color};
    background-color: ${p.$backgroundColor};
  `}
`
